import dayjs from "dayjs";

const dayLeft = (endDay) => {
    return dayjs(endDay).diff(dayjs(), "day"); // how much day until event end
}

export {dayLeft};